import ReportPage from './ReportPage'

export default function PromosReport({className = ''}: {className?: string}) {
  return <ReportPage type='promocoes' className={className} />
}
